
import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login'
import TeacherView from './components/TeacherView'
import StudentView from './components/StudentView'
import NotSupported from './components/NotSupported'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/TeacherView',
      name: 'TeacherView',
      component: TeacherView
    },
    {
      path: '/StudentView',
      name: 'StudentView',
      component: StudentView
    },
    {
      path: '/NotSupported',
      name: 'NotSupported',
      component: NotSupported
    }
  ]
})